<template>
      <v-card hover flat>
                 <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1">Verificar CPC</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 2" step="2">Detalle Solvencia</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 3" step="2">Registro del Pago</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-form v-on:submit.prevent="validarCpc" ref="formcpc" v-model="validcpc" lazy-validation>
                                <v-card class="elevation-0 mb-5" height="100px">
                                    <v-card-text>
                                        <v-layout justify-center>
                                        <v-flex xs12 sm6 md4 lg4 align-center justify-center>
                                            <v-text-field
                                                ref="cpc"
                                                v-model="form.cpc"
                                                prepend-icon="featured_video"
                                                label="Ingresa el CPC"
                                                :rules="[v => !!v || 'CPC es requerido']"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn @click="cerrarDialog(null)">SALIR</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="validarCpc">CONTINUAR</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <h3>Solvente hasta: {{ fecha_solvencia }}</h3>
                                <v-data-table
                                    :items="invoice"
                                    class="elevation-0"
                                    hide-actions
                                    :headers="headers"
                                    :expand="expand"
                                    no-data-text=""
                                    item-key="code"
                                >
                                    <template v-slot:items="props">
                                        <tr>
                                            <td>{{ props.item.cuota }}</td>
                                            <td>{{ props.item.concepto }}</td>
                                            <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.amount) }} Bs</td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Sub-Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(subTotal) }} Bs</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>IVA</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(iva) }} Bs</strong>
                                            </td>
                                        </tr>
                                        <tr v-if="posee_pagos">
                                            <td colspan="2">
                                                <strong>Pagado</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(acumulado_pagos) }} Bs</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(total) }} Bs</strong>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-card-actions>
                                    <v-btn @click="cerrarDialog(null)">SALIR</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="e1 = 3">CONTINUAR</v-btn>
                                </v-card-actions>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-form v-on:submit.prevent="cargarPago" ref="formcargarpago" v-model="validcargarpago" lazy-validation enctype="multipart/form-data">
                                <v-card class="elevation-0 mb-5">
                                    <v-card-text>
                                        <v-flex xs12 align-center justify-space-between>
                                            <v-layout align-center>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        disabled
                                                        ref="rif"
                                                        v-model="form.rif"
                                                        prepend-icon="featured_video"
                                                        label="RIF"
                                                        :rules="[v => !!v || 'RIF es requerido']"
                                                        required
                                                        mask="A-########-#"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm8>
                                                    <v-text-field
                                                        disabled
                                                        ref="razonsocial"
                                                        v-model="form.razon_social"
                                                        prepend-icon="person"
                                                        label="Razon social"
                                                        :rules="[v => !!v || 'Razon social es requerido']"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                ref="direccionfiscal"
                                                v-model="form.direccion_fiscal"
                                                prepend-icon="domain"
                                                label="Direccion Fiscal"
                                                :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                       <v-flex xs12 align-center justify-space-between>
                                            <v-layout align-center>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        prepend-icon="account_balance_wallet"
                                                        :items="wayToPay"
                                                        v-model="form.way_to_pay"
                                                        @change="changeWayToPay"
                                                        label="Método de pago"
                                                        :rules="[v => !!v || 'Método de pago es requerido']"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                                        <div class="v-input__prepend-outer">
                                                            <div class="v-input__icon v-input__icon--prepend">
                                                                <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                                            </div>
                                                        </div>
                                                        <div class="v-input__control">
                                                            <div class="v-input__slot">
                                                                <div class="v-text-field__slot">
                                                                    <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a Acreditar</label>
                                                                    <vue-numeric currency="BsS" v-model="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select
                                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                                prepend-icon="account_balance"
                                                :items="banks"
                                                v-model="form.bank_id"
                                                item-text="name"
                                                item-value="id"
                                                label="Banco"
                                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 align-center justify-space-between>
                                            <v-layout align-center>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                                        ref="number"
                                                        v-model="form.number"
                                                        prepend-icon="remove"
                                                        label="Número de transacción"
                                                        mask="###############"
                                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-menu
                                                        ref="menu"
                                                        lazy
                                                        :close-on-content-click="false"
                                                        v-model="menu"
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        :nudge-right="40"
                                                        min-width="290px"
                                                        :return-value.sync="date"
                                                    >
                                                        <v-text-field
                                                            slot="activator"
                                                            label="Fecha"
                                                            v-model="computedDateFormattedFecha"
                                                            hint="DD/MM/YYYY formato"
                                                            prepend-icon="event"
                                                            :rules="[v => !!v || 'Fecha es requerido']"
                                                            required
                                                            readonly
                                                        ></v-text-field>
                                                        <v-date-picker color="primary" :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date" no-title scrollable>
                                                        <v-spacer></v-spacer>
                                                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                                            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea
                                                prepend-icon="reorder"
                                                v-model="form.observations"
                                                auto-grow
                                                color="primary"
                                                label="Observación"
                                                rows="2"
                                                :rules="[v => !!v || 'La Observación es Requerida']"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12>
                                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                                            <v-text-field
                                                :rules="[v => !!v || 'Comprobante de pago es requerido']"
                                                ref="document"
                                                v-model="nameImg"
                                                @click.native="onFocus"
                                                prepend-icon="attach_file"
                                                label="Comprobante de pago"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn @click="cerrarDialog(null)">SALIR</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="cargarPago">CONTINUAR</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-stepper-content>
                       
                    </v-stepper-items>
                </v-stepper>        
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import VueNumeric from 'vue-numeric'

export default {
    
    name: 'form-nota-credito-view',

    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },

    components: {
        VueNumeric
    },

    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }
    },

    data: () => ({
        e1: 0,
        diferencia_pago: false,
        posee_pagos: false,
        date: null,
        fecha: null,
        menu: false,
        expand: false,
        validpago: false,
        estado_solvencia: null,
        estado_solvencia_pendiente: false,
        validcpc: false,
        validcargarpago: false,
        date: null,
        fecha: null,
        menu: false,
        nameImg: '',
        fecha_solvencia: '',
        wayToPay: ['TRANSFERENCIA'],
        banks: [],
        servicio_admin_object: [],
        servicio_admin: [],
        invoice: [],
        acumulado_pagos: 0.00,
        total: 0.00,
        subTotal: 0.00,
        iva: 0.00,
        headers: [
            { text: 'CUOTA', value: '', sortable: false },
            { text: 'ITEM', value: '', sortable: false },
            { text: 'MONTO', value: '', sortable: false, align: 'right' },
        ],
        form: new Form({
            cpc: '',
            way_to_pay: 'TRANSFERENCIA',
            number: null,
            ruap_id: null,
            amount: 0.00,
            rif: '',
            razon_social: '',
            direccion_fiscal: '',
            payment_date: '',
            observations: '',
            file: '',
            document: '',
            agreement: false
        })
    }),

    mounted() {
        this.$store.dispatch('clearMessage')
    },

    methods: {

        async validarCpc() {
            if (this.$refs.formcpc.validate()) {
                this.$emit('responseLoading', true)
                await axios.get(`/api/cliente/estado-solvencia?cpc=${this.form.cpc}`)
                    .then(res => {
                        this.banks = res.data.banks
                        let total_payments = 0

                        let solvente_hasta = res.data.solvente_hasta
                        let fecha_actual = new Date();
                        let fecha = fecha_actual;

                        if (solvente_hasta != "") {
                            if (solvente_hasta[0].solvente_hasta == null || solvente_hasta[0].solvente_hasta == "") {
                                this.$store.dispatch('responseMessage', {
                                    type: 'success',
                                    text: 'El agremiado esta solvente'
                                })
                            }else {
                                fecha = new Date(solvente_hasta[0].solvente_hasta)
                                let day = fecha.getDate()
                                let month = fecha.getMonth() + 1
                                let year = fecha.getFullYear()
                                this.fecha_solvencia = `${day}/${month}/${year}`

                                this.servicio_admin_object = res.data.concept_servadmon
                                this.servicio_admin = parseFloat(this.servicio_admin_object.amount)

                                let iva_serv_admin = 0
                                iva_serv_admin = parseFloat(this.servicio_admin * 0.16);

                                if (res.data.solvencia) {
                                    if (res.data.existe_deuda.length == 0) {
                                        this.estado_solvencia = true
                                        if (res.data.invoice_pagada == null) {
                                            this.estado_solvencia = false
                                            this.inactive_logica = true
                                        }
                                    }else {
                                        this.invoice = res.data.existe_deuda
                                        this.invoice.push({
                                            amount: this.servicio_admin,
                                            concept_cost_id: this.servicio_admin_object.id,
                                            cuota: this.servicio_admin_object.code,
                                            concepto: this.servicio_admin_object.name
                                        })
                                        this.form.rif = res.data.invoice_pagada.rif
                                        this.form.razon_social = res.data.invoice_pagada.razon_social
                                        this.form.direccion_fiscal = res.data.invoice_pagada.direccion_fiscal
                                        this.estado_solvencia = false
                                        this.iva = iva_serv_admin
                                        this.total = parseFloat(res.data.total) + this.servicio_admin
                                        this.form.amount = parseFloat(this.total)
                                        this.subTotal = this.total
                                        this.total = this.total + this.iva
                                    }
                                }else {
                                        if (res.data.invoice == null) {
                                            if (res.data.invoice_pagada == null) {
                                                this.inactive_logica = true
                                                this.estado_solvencia = false
                                            }
                                        }else {
                                            if (res.data.existe_deuda.length == 0) {
                                                if(res.data.invoice.payments.length != 0){
                                                    this.posee_pagos = true
                                                    this.diferencia_pago = true
                                                    this.invoice.forEach(e => {
                                                        if(e.agreement){
                                                            total_payments += parseFloat(e.amount)
                                                        }
                                                    });
                                                    this.acumulado_pagos = parseFloat(total_payments)
                                                }else {
                                                    this.posee_pagos = false
                                                }
                                                this.form.rif = res.data.invoice_pagada.rif
                                                this.form.razon_social = res.data.invoice_pagada.razon_social
                                                this.form.direccion_fiscal = res.data.invoice_pagada.direccion_fiscal
                                                this.invoice = res.data.invoice
                                                this.estado_solvencia = false
                                                this.estado_solvencia_pendiente = true
                                                this.iva = iva_serv_admin
                                                this.total = parseFloat(res.data.invoice.amount) + this.servicio_admin
                                                this.form.amount = parseFloat(this.total)
                                                this.subTotal = this.total
                                                this.total = this.total + this.iva
                                            }else {
                                                if(res.data.invoice.payments.length != 0){
                                                    this.posee_pagos = true
                                                    this.diferencia_pago = true
                                                    res.data.invoice.payments.forEach(e => {
                                                        if(e.agreement){
                                                            total_payments += parseFloat(e.amount)
                                                        }
                                                    });
                                                    this.acumulado_pagos = parseFloat(total_payments)
                                                }else {
                                                    this.posee_pagos = false
                                                }
                                                this.invoice = res.data.existe_deuda
                                                this.invoice.push({
                                                    amount: this.servicio_admin,
                                                    concept_cost_id: this.servicio_admin_object.id,
                                                    cuota: this.servicio_admin_object.code,
                                                    concepto: this.servicio_admin_object.name
                                                })
                                                this.form.rif = res.data.invoice_pagada.rif
                                                this.form.razon_social = res.data.invoice_pagada.razon_social
                                                this.form.direccion_fiscal = res.data.invoice_pagada.direccion_fiscal
                                                this.estado_solvencia = false
                                                this.iva = iva_serv_admin
                                                this.total = parseFloat(res.data.total) + this.servicio_admin
                                                this.form.amount = parseFloat(this.total)
                                                this.subTotal = this.total
                                                this.total = this.total + this.iva
                                            }

                                        }
                                    }
                                    if(this.diferencia_pago) {
                                        this.form.amount = this.total - this.acumulado_pagos
                                        this.total = this.total - this.acumulado_pagos
                                    }else {
                                        this.form.amount = this.total
                                    }
                                    this.e1 = 2


                            }
                        }else if (solvente_hasta == "" || solvente_hasta == null){
                            this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: 'El agremiado esta solvente'
                            })
                        }else {
                           this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: 'El agremiado esta solvente'
                            })
                        }



                    }).catch(e => {
                        if (e.response.data.errors) {
                            if (e.response.data.errors.unionize) {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.errors.unionize
                                })
                            }
                        }
                    }).finally(() => this.$emit('responseLoading', false));
            }
        },

            
        async cargarPago () {
            if (this.$refs.formcargarpago.validate()) {
                if(this.form.amount == 0){
                    this.$store.dispatch('responseMessage', {
                        type: 'info',
                        text: `Ingrese el monto a registrar`
                    })
                }else {
                    this.$emit('responseLoading', true)
                    let formData = new FormData();
                    for (var key in this.form) {
                        formData.append(key, this.form[key]);
                    }
                    console.log('paso')
                    await axios.post('/api/cliente/ap-pay-solvencia-administrativo', formData).then(resp => {
                        this.cerrarDialog(resp)
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: `Registro Exitoso`
                        })
                    }).catch(e => {
                        console.log(e.response)
                        if (e.response.data.errors) {
                            if (e.response.data.errors.file) {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.errors.file
                                })
                            }else if (e.response.data.errors.pago) {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.errors.pago
                                })
                            } else {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.error
                                })
                            }
                        }
                    }).finally(() => this.$emit('responseLoading', false))
                }
            }
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async changeWayToPay() {
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        onFocus() {
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
                this.form.file = files[0]
                this.nameImg = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
                })
            }
        },

        cerrarDialog (data) {
            this.$emit('closeDialogPagoSolvencia', data)
            this.$nextTick(() => {
                this.e1 = 1
                this.form = {
                    cpc: '',
                    rif: '',
                    razon_social: '',
                    direccion_fiscal: '',
                    bank_id: '',
                    way_to_pay: 'TRANSFERENCIA',
                    amount: 0,
                    number: null,
                    payment_date: '',
                    observations: '',
                    file: '',
                }
                this.nameImg = ''
                this.$refs.formcpc.resetValidation()
                this.$refs.formcargarpago.resetValidation()
                this.$emit('responseLoading', false)
            })
        }

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/FormPagoSolvencia.vue